import instance from './DefaultApi';

export default class DispatchReportService {
    ControllerName = 'DispatchReport';

    // get all data
    GetDispatchReport(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchReport`, tableRequest).then(res => res)
    }
    //get export for Dispatch report
    GetReportExportDispatch(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetReportExportDispatch`, tableRequest).then(res => res)
    }
    //To Print Dispatch detail
    GetDispatchToPrint(d) {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchToPrint`, d).then(res => res)
    }

}